var exports = {
  "j": "xe533113f--78397b--cont",
  "K": "xe533113f--78397b--icon",
};

module.exports = exports;
